<template>
  <div class="py-6">
    <div class="flex items-start justify-between">
      <LabelValue class="pr-8" :label="t('Reviews.product.view.globalFeatures.title').toString()">
        <template #hint>
          {{ t('Reviews.product.view.globalFeatures.description') }}
        </template>
      </LabelValue>
      <OpenProductProfile class="shrink-0" :slug="product.slug" />
    </div>
    <div v-if="!hasGlobalFeatures" class="flex text-main">
      <MdiSvg class="mr-1" :path="mdiInformationOutline" />
      <div class="text-body-m">{{ t('Reviews.product.view.globalFeaturesHint') }}</div>
    </div>
    <ProductGlobalFeaturesProvider
      class="mb-6 grid grid-cols-3 gap-6"
      :product="{
        cloud: product.cloud,
        anytimeSupport: product.anytimeSupport,
        onPremise: product.onPremise,
        germanSupport: product.germanSupport,
        germanLocation: product.germanLocation,
        euLocation: product.euLocation,
        euStandardContract: product.euStandardContract,
        euCompanyAffiliated: product.euCompanyAffiliated,
        freePlanAvailable: product.freePlanAvailable,
        freeTrial: product.freeTrial,
      }"
    >
      <template #default="{ dataPrivacy, setupAndSupport, versions }">
        <ProductFeaturesGroup
          class="pb-6"
          data-testid="features-setup-and-support"
          :items="setupAndSupport.items"
          :title="setupAndSupport.title"
          title-classes="text-headline-xs pb-2 border-b border-b-solid border-main"
        />
        <ProductFeaturesGroup
          class="pb-6"
          data-testid="features-data-privacy"
          :items="dataPrivacy.items"
          :title="dataPrivacy.title"
          title-classes="text-headline-xs pb-2 border-b border-b-solid border-main"
        />
        <ProductFeaturesGroup
          data-testid="features-versions"
          :items="versions.items"
          :title="versions.title"
          title-classes="text-headline-xs pb-2 border-b border-b-solid border-main"
        />
      </template>
    </ProductGlobalFeaturesProvider>
  </div>
</template>
<script setup lang="ts">
import { mdiInformationOutline } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { ProductGlobalFeaturesProvider, ProductFeaturesGroup } from '@ramp106/omrjs-reviews-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import OpenProductProfile from '@/components/ReviewsManagement/OpenProductProfile.vue'
import type { ProductById } from '@/gql/reviews'
import LabelValue from '@/ui/LabelValue.vue'

const props = defineProps<{
  product: ProductById
}>()

const { t } = useI18n()

const hasGlobalFeatures = computed(() => {
  return (
    props.product.cloud !== null ||
    props.product.onPremise !== null ||
    props.product.anytimeSupport !== null ||
    props.product.germanSupport !== null ||
    props.product.germanLocation !== null ||
    props.product.euLocation !== null ||
    props.product.euCompanyAffiliated !== null ||
    props.product.euStandardContract !== null
  )
})
</script>
